"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _airbnbPropTypes = require("airbnb-prop-types");

var _styler = _interopRequireDefault(require("../Styler/styler"));

var _getNativeProps = _interopRequireDefault(require("../helpers/get-native-props"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function Row(_ref) {
  var children = _ref.children,
      onClick = _ref.onClick,
      props = _objectWithoutProperties(_ref, ["children", "onClick"]);

  var rowStyles = ['co-table__row', {
    'co-table__row--clickable': onClick
  }];

  var allowedModifiers = _objectSpread({}, props);

  return _react.default.createElement(_styler.default, {
    classNames: rowStyles,
    modifiers: allowedModifiers
  }, function (styles) {
    return _react.default.createElement("tr", _extends({
      onClick: onClick,
      className: styles
    }, (0, _getNativeProps.default)(props)), children);
  });
}

var exclusiveRowColorsVariations = (0, _airbnbPropTypes.mutuallyExclusiveTrueProps)('success', 'danger', 'info', 'warning');
Row.displayName = 'Table.Row';
Row.propTypes = {
  /** {---} Sequence of: @@Table.Data@@ (optional, min: 1), @@Table.ActionData@@ (optional, max: 1) OR @@Table.Header@@ (optional, min: 1), @@Table.ActionHeader@@ (optional, max: 1) */
  children: _propTypes.any.isRequired,
  disabled: _propTypes.bool,
  active: _propTypes.bool,

  /** {bool} Mutually exclusive props: @@success@@ @@danger@@ @@info@@ @@warning@@ */
  success: exclusiveRowColorsVariations,

  /** {bool} Mutually exclusive props: @@success@@ @@danger@@ @@info@@ @@warning@@ */
  danger: exclusiveRowColorsVariations,

  /** {bool} Mutually exclusive props: @@success@@ @@danger@@ @@info@@ @@warning@@ */
  info: exclusiveRowColorsVariations,

  /** {bool} Mutually exclusive props: @@success@@ @@danger@@ @@info@@ @@warning@@ */
  warning: exclusiveRowColorsVariations,
  onClick: _propTypes.func
};
var _default = Row;
exports.default = _default;
Row.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Table.Row",
  "props": {
    "children": {
      "type": {
        "name": "any"
      },
      "required": true,
      "description": "{---} Sequence of: @@Table.Data@@ (optional, min: 1), @@Table.ActionData@@ (optional, max: 1) OR @@Table.Header@@ (optional, min: 1), @@Table.ActionHeader@@ (optional, max: 1)"
    },
    "disabled": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "active": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "success": {
      "type": {
        "name": "custom",
        "raw": "exclusiveRowColorsVariations"
      },
      "required": false,
      "description": "{bool} Mutually exclusive props: @@success@@ @@danger@@ @@info@@ @@warning@@"
    },
    "danger": {
      "type": {
        "name": "custom",
        "raw": "exclusiveRowColorsVariations"
      },
      "required": false,
      "description": "{bool} Mutually exclusive props: @@success@@ @@danger@@ @@info@@ @@warning@@"
    },
    "info": {
      "type": {
        "name": "custom",
        "raw": "exclusiveRowColorsVariations"
      },
      "required": false,
      "description": "{bool} Mutually exclusive props: @@success@@ @@danger@@ @@info@@ @@warning@@"
    },
    "warning": {
      "type": {
        "name": "custom",
        "raw": "exclusiveRowColorsVariations"
      },
      "required": false,
      "description": "{bool} Mutually exclusive props: @@success@@ @@danger@@ @@info@@ @@warning@@"
    },
    "onClick": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    }
  }
};